import React, { useContext } from 'react';
import { CTA, styled } from '@volkswagen-onehub/components-core';
import { ResultsView, ResultsViewContext } from '../../utils/results-view-context';
import { GridView } from '../../svg/GridView';
import { ListView } from '../../svg/ListView';
import { useFeatureServices } from '../../use-feature-services';
import { createConfiguration, createConstantData, createPartner, createProcess } from '../../utils/get-tracking-event-data';
import { useLocation } from 'react-router-dom';
import { getTranslations } from '../../translations';
import { getSingleSelectedDealer } from '../../utils/get-single-selected-dealer';
import { getStep } from '../../utils/get-step';

const ToggleContainer = styled.div`
  display: flex;
`;

interface Props {
  selected: boolean;
}

const StyledCTA = styled(CTA)<Props>`
  ${
    ({ selected }) =>
      !selected
      ? `
        color: #eaeaea;
        :hover {
          color: #001E50;
        }
        `
      : null
  }
`;

export const ViewToggle = () => {
  const { set: setView, value } = useContext(ResultsViewContext);
  const { tracking } = useFeatureServices();
  const { aria } = getTranslations();

  const route = useLocation();
  const step = getStep(route.pathname);

  const partner = getSingleSelectedDealer();

  const handleClick = (view: ResultsView) => {
    setView(view);
    tracking.track('VWBasic_Button_Click', {
      ...createConstantData(),
      configuration: createConfiguration(),
      partner: createPartner(partner),
      process: createProcess(step),
      link: {
        url: window.location.href,
        name: `${view} view`
      }
    })
  };

  return (
    <ToggleContainer>
      <StyledCTA
        selected={value === ResultsView.LIST}
        tag="button"
        emphasis="tertiary"
        icon={<ListView ariaHidden />}
        onClick={() => handleClick(ResultsView.LIST)}
        ariaLabel={aria.view_list}
      />
      <StyledCTA
        selected={value === ResultsView.GRID}
        tag="button"
        emphasis="tertiary"
        icon={<GridView ariaHidden />}
        onClick={() => handleClick(ResultsView.GRID)}
        ariaLabel={aria.view_grid}
      />
    </ToggleContainer>
  );
};
